import { useNavigate } from "react-router-dom";

import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { CustomerSupportVulnerabilityCircumstanceAgeInput } from "../../../generated/customer/schema.graphql";

type AgeQuestion = Partial<
  Record<keyof CustomerSupportVulnerabilityCircumstanceAgeInput, string>
>;
export const ageQuestions: AgeQuestion = {
  under66: "Under 66",
  between66And74: "Between 66 - 74",
  between75And84: "Between 75 - 84",
  over85: "85+",
};

const AgeDetail: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (answer: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      ageDetail: answer,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.AgeCareDetail}`);
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={ageQuestions}
      values={answers.ageDetail}
      onContinue={onContinue}
      step={questionContent.ageDetail.step}
      title={questionContent.ageDetail.title}
      subTitle={questionContent.ageDetail.subTitle}
      whyWeWantTexts={questionContent.ageDetail.whyWeWantTextsCustomer}
      requireAnswer
    />
  );
};

export default AgeDetail;
